<!-- Use this one for modals like LoginModal, SuccessModal -->
<template>
  <div class="modal">
    <div class="modal__overlay" @click="$emit('clickOverlay')"></div>
    <div class="modal__body" :class="{ 'modal__body_round': roundBorder }">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    roundBorder: {
      type: Boolean,
      default: true,
    },
  },
};
</script>


<style lang="scss" scoped>
.modal {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10000;
  width: 100%;
  overflow-y: auto;

  &__overlay {
    width: 100%;
    height: 100%;
    background: $black-color5;
    z-index: 1;
    position: fixed;
  }
  &__body {
    margin: auto $modal-side-margin;
    position: relative;
    z-index: 10001;
    &_round {
      border-radius: 5px;
      overflow: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/ModalBase.vue